import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import * as commonActions from '@common/common.action';
import * as DescarteMateriaisRelatoriosActions from '../descarte/tabs/relatorios/store/relatorios.action';
import * as DescarteMateriaisActions from '../descarte/common/store/descarte.action';
import CommonFunctions from '@common/util/functions.common';
import LaudoCritico from './LaudoCritico';
import DescarteMateriaisRelatorios from '../descarte/tabs/relatorios';
import ArquivamentoRelatorios from '../arquivamento/tabs/Relatorios';
import ControleTarefas from '../controleTarefas/controle-tarefas.container';
import Solicitacoes from '../solicitacao/Solicitacoes';
import Faturamento from '../../pages/relatorio/Faturamento/index';
import './styles.css';
import Total from '../solicitacao/Total';
import LaudoSemCid from './LaudoSemCid';
import IntlMessage from '../../helpers/intlMessage';
import {BsFillPersonVcardFill} from 'react-icons/bs';
import Certificacao from './Certificacao';

function Relatorio() {
  const dispatch = useDispatch();

  const [currentTab, setCurrentTab] = useState('0');

  useEffect(() => {
    setTimeout(() => setCurrentTab('1'), 200);
  }, []);

  useEffect(() => {
    const periodo = CommonFunctions.getPeriodosSubDays(0);
    const { periodoInicial, periodoFinal } = periodo;
    dispatch(DescarteMateriaisActions.atualizarTab('3'));
    dispatch(DescarteMateriaisRelatoriosActions.dataInicio(periodoInicial));
    dispatch(DescarteMateriaisRelatoriosActions.dataFim(periodoFinal));
  }, [currentTab]);

  const mudarAba = (event, tab) => {
    setCurrentTab(tab);
  };

  const showMessageByResults = results => {
    if (results > 0) {
      const mensagem = <IntlMessage id="dashboards.general.recordsFound" />
      dispatch(commonActions.showAlerta('sucesso', mensagem, 3000));
    } else {
      dispatch(
        commonActions.showAlerta('alerta', <IntlMessage id="dashboards.reports.noResultsFound" />, 3000)
      );
    }
  };

  return (
    <div className='mv-relatorios-page'>
      <TabContext value={currentTab}>
        <AppBar position='static' color='default'>
          <Tabs
            value={currentTab}
            onChange={mudarAba}
            variant='scrollable'
            indicatorColor='primary'
            textColor='primary'
            aria-label='scrollable force tabs example'
          >
            <Tab
              icon={<i className='tab-icons fas fa-plus-circle'></i>}
              label={<IntlMessage id="dashboards.reports.criticalReport" />}
              value='1'
            />
            <Tab
              icon={<i className='tab-icons mv-basico-excluir'></i>}
              label={<IntlMessage id="dashboards.reports.disposalMaterials" />}
              value='2'
            />
            <Tab
              icon={<i className='tab-icons mv-basico-arquivar'></i>}
              label={<IntlMessage id="dashboards.reports.archiving" />}
              value='3'
            />
            <Tab
              icon={<i className='tab-icons mv-basico-consulta'></i>}
              label={<IntlMessage id="dashboards.reports.taskControl" />}
              value='4'
            />
            <Tab
              icon={<Total />}
              label={<span style={{ marginRight: '18px' }}>{<IntlMessage id="dashboards.reports.requestsPanel" />}</span>}
              value='5'
            />
            <Tab
              icon={<i className='tab-icons mv-basico-documento_eletronico' />}
              label={<IntlMessage id="dashboards.reports.reportsCID" />}
              value='6'
            />
            <Tab
              icon={<i className='tab-icons mv-basico-faturamento' />}
              label={<IntlMessage id="dashboards.reports.invoicing" />}
              value='7'
            />
            <Tab
              icon={<BsFillPersonVcardFill style={{marginRight: '10px'}} />}
              label={<IntlMessage id="dashboards.general.certificationTab" />}
              value='8'
            />
            <Tab value='0' disabled></Tab>
          </Tabs>
        </AppBar>
        <TabPanel value='0'></TabPanel>
        <TabPanel value='1'>
          <LaudoCritico showMessageByResults={showMessageByResults} />
        </TabPanel>
        <TabPanel value='2'>
          <DescarteMateriaisRelatorios />
        </TabPanel>
        <TabPanel value='3'>
          <ArquivamentoRelatorios showMessageByResults={showMessageByResults} />
        </TabPanel>
        <TabPanel value='4'>
          <ControleTarefas hideTitulo />
        </TabPanel>
        <TabPanel value='5'>
          <Solicitacoes />
        </TabPanel>
        <TabPanel value='6'>
          <LaudoSemCid />
        </TabPanel>
        <TabPanel value='7'>
          <Faturamento commonActions={commonActions} />
        </TabPanel>
        <TabPanel value='8'>
          <Certificacao commonActions={commonActions} />
        </TabPanel>
      </TabContext>
    </div>
  );
}

export default Relatorio;


// WEBPACK FOOTER //
// ./src/pages/relatorio/relatorio.container.js